<template>
  <div class="mypage-blocked-user-list-pane">
    <mypage-blocked-user-list-section />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypageBlockedUserListSection from '@/components/MypageBlockedUserListPage/MypageBlockedUserListPane/MypageBlockedUserListSection.vue'

export default defineComponent({
  name: 'MypageBlockedUserListPane',
  components: { MypageBlockedUserListSection },
})
</script>
